import React, {useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import SearchIcon from '@material-ui/icons/Search';
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import {makeStyles} from "@material-ui/core";
import AddrForm from "../common/AddrForm";
import List from "@material-ui/core/List";
import {initializeForm, searchAddress} from "../../modules/address";
import SentenceForm from "../common/SentenceForm";
import {editHouseAddress, editHouseData} from "../../modules/rent";
import {useRecoilState} from "recoil";
import {rentState} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: 550,
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    }
}));

const RentHouseAddress = ({id}) => {
    const [rent, setRent] = useRecoilState(rentState);
    const [keyword, setKeyword] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const house = rent.house[id];
    const classes = useStyles();
    const dispatch = useDispatch();
    const address = useSelector(state => state.address);
    const {validateMode} = useSelector(state => state.answers);
    const addrDetlsRef = useRef(null);

    // 도로명주소 선택 이벤트 처리
    const handleOnSelect = (road, detail, base, zpcd) => {
        const newHouseData = {
            ...house,
            rentAgentZpcd: zpcd,
            rentAgentAddr: road
        };

        const newRentData = {
            ...rent,
            house: {
                ...rent.house,
                [id]: newHouseData
            }
        }
        setRent(newRentData);

        setOpen(false);

        setTimeout(function() {
            addrDetlsRef.current.focus();
        }, 500);
    };

    const handleInputAnswer = (val) => {
        if (val.length <= 50) {
            const newHouseData = {
                ...house,
                rentAgentAddrDetls: val,
            };

            const newRentData = {
                ...rent,
                house: {
                    ...rent.house,
                    [id]: newHouseData
                }
            }
            setRent(newRentData);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleClickOpenDialog();
        }
    }

    const handleClickOpenDialog = async () => {
        dispatch(searchAddress(keyword));
    };

    const handleClickOpen = () => {
        setKeyword('');
        dispatch(initializeForm(null));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        dispatch(initializeForm(null));
    };

    const handleInputChange = (e) => {
        setKeyword(e.target.value);
    };

    return (
        <>
            <div>
                <SentenceForm
                    title="임대 부동산(사업) 주소"
                    sentences={[]}
                    step={30}
                />
                <Grid container
                      alignItems='center'
                      style={{margin: '0 20px'}}>
                    <Grid item md={12} sm={12} xs={12}>
                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick = {handleClickOpen}
                        >
                            주소검색
                        </Button>
                    </Grid>
                    <Grid item md={8} sm={8} xs={12} style={{marginRight: 30, marginTop: 10}}>
                        <TextField
                            required
                            key={`rent-addr-${id}`}
                            label="도로명 주소"
                            fullWidth={true}
                            margin="none"
                            // disabled={true}
                            value={house.rentAgentAddr}
                        />
                    </Grid>
                    <Grid item md={3} sm={3} xs={12} style={{marginRight: 30, marginTop: 10}}>
                        <TextField
                            required
                            key='addr_detail'
                            label="상세 주소"
                            fullWidth={true}
                            margin="none"
                            inputRef={addrDetlsRef}
                            value={house.rentAgentAddrDetls}
                            onChange={(e) => handleInputAnswer(e.target.value)}
                            error={validateMode && house.rentAgentAddrDetls === ""}
                            helperText={(validateMode && house.rentAgentAddrDetls === "") && "필수 입력 항목입니다."}
                        />
                    </Grid>
                </Grid>
            </div>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth='sm'>
                <DialogTitle id="form-dialog-title">도로명 주소 검색</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        도로명 주소를 입력하세요.
                    </DialogContentText>
                    <Grid container
                          alignItems='center'>
                        <Grid item md={11}>
                            <TextField
                                required
                                id="outlined-required"
                                label="도로명"
                                margin="normal"
                                fullWidth={true}
                                variant="outlined"
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                autoFocus={true}
                                value={keyword}
                            />
                        </Grid>
                        <Grid item md={1}>
                            <IconButton aria-label="search" onClick={handleClickOpenDialog}>
                                <SearchIcon />
                            </IconButton>
                        </Grid>
                    </Grid>

                    <Paper className={classes.root}>
                        <List>
                            {address.address && address.address.map((item, idx) => (
                                <AddrForm key={'ADDR_' + idx} roadAddr={item.roadAddr} roadAddrDetail={item.bdNm}
                                          jibun={item.jibunAddr} zpcd={item.zpcd} onItemClick={handleOnSelect} />
                            ))}
                            {!address.address && address.errorMessage && <p style={{color: 'red'}}>{address.errorMessage}</p>}
                        </List>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        닫기
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RentHouseAddress;
